<template>
    <div class="page">
        <div class="page-content">
            <div class="p-home">
                <div class="top-box">
                    <div class="no-login" @click="$router.push('/login')">
                        <img src=""/>
                        <div>登录</div>
                    </div>
                </div>
                <div class="shadow-box item-box">
                    <ul class="clearfix">
                        <li @click="$router.push('/card/credit')">
                            <i class="iconfont co-l1 icon-56"></i>办信用卡
                        </li>
                        <li @click="$router.push('/loan')">
                            <i class="iconfont co-l2 icon-18"></i>贷款
                        </li>
                        <li @click="$router.push('/baoxian')">
                            <i class="iconfont co-l3 icon-91"></i>保险
                        </li>
                        <li @click="$router.push('/autoinsurance')">
                            <i class="iconfont co-l4 icon-79"></i>车险
                        </li>
                        <li @click="$router.push('/doTask')">
                            <i class="iconfont co-l5 icon-92"></i>做任务
                        </li>
                        <li @click="$router.push('/invitation')">
                            <i class="iconfont co-l6 icon-96"></i>邀请好友
                        </li>
                        <li>
                            <i class="iconfont co-l7 icon-63"></i>信用报告
                        </li>
                        <li @click="$router.replace('/user')">
                            <i class="iconfont co-l8 icon-68"></i>用户中心
                        </li>
                    </ul>
                </div>
                <div class="shadow-box welcomen-box">
                    <div class="hd">欢迎加入聚惠享</div>
                    <div class="bd">
                        <div class="tow-box">
                            <div class="item">
                                <h2>25765人</h2>
                                <p class="p2">已在平台赚钱</p>
                            </div>
                            <div class="item">
                                <h2>25765元</h2>
                                <p class="p2">累计发放佣金</p>
                            </div>
                        </div>
                        <div class="jsme">今日免费申请名额仅剩:<a v-for="item in conut">{{item}}</a>名</div>
                        <div><a class="btn">免费升级赚钱</a></div>
                    </div>
                </div>
                <p class="block-title">平台优势</p>
                <img class="index-full-img mb15" src="../assets/images/xhdaj.png"/>
                <ul class="index-ad-list">
                    <li class="title"><span>最新活动</span></li>
                    <li><img src="../assets/images/sss1.png"/></li>
                    <li><img src="../assets/images/sss2.png"/></li>
                    <li><img src="../assets/images/sss3.png"/></li>
                </ul>
                <ul class="recommend-list">
                    <li class="title"><span>最新推荐</span></li>
                    <li class="flex item shadow" v-for="item in cardList" @click="$router.push('/card/detail')">
                        <div class="l-bbb"><img src="../assets/images/cd-card.png"/></div>
                        <div>
                            <h4>{{item.name}}</h4>
                            <p class="p1">{{item.desc}}</p>
                            <p class="tags">
                                <a v-for="tag in item.tags">{{tag}}</a>
                            </p>
                        </div>
                    </li>
                </ul>
                <p class="block-title">合作单位</p>
                <img class="index-full-img" src="../assets/images/bank-list.png"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            cardList: [{
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }, {
                img: '../assets/images/cd-card.png',
                name: '交行标准信用卡金卡',
                desc: '每周五超市、加油乐享5%优惠',
                tags: ['加油优惠', '超长免息']
            }]
        }
    },
    computed: {
        conut () {
            var count = '345'
            return count
        }
    }
}
</script>
